import { render } from "./RejectWithComment.vue?vue&type=template&id=29cd8cb6&scoped=true"
import script from "./RejectWithComment.vue?vue&type=script&lang=js"
export * from "./RejectWithComment.vue?vue&type=script&lang=js"

import "./RejectWithComment.vue?vue&type=style&index=0&id=29cd8cb6&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cd8cb6"]])

export default __exports__